import { Type } from '@angular/core';
import { OverviewDisplayComponent } from '@products/overview/overview-display-component.interface';
import { MainFundContentComponent } from '@products/overview/main-fund-content/main-fund-content.component';
import { FundHeaderComponent } from '@products/overview/fund-header/fund-header.component';
import { FundTabsComponent } from "@products/overview/fund-tabs/fund-tabs.component";

export class OverviewComponentConfig {
  static readonly FUND_TABS = new OverviewComponentConfig(
    'Fund Tabs',
    FundTabsComponent
  );

  static readonly FUND_HEADER = new OverviewComponentConfig(
    'Fund Header',
    FundHeaderComponent
  );

  static readonly MAIN_OVERVIEW = new OverviewComponentConfig(
    'Overview Main',
    MainFundContentComponent
  );

  static allConfigs: OverviewComponentConfig[] = [
    OverviewComponentConfig.FUND_HEADER,
    OverviewComponentConfig.MAIN_OVERVIEW,
    OverviewComponentConfig.FUND_TABS,
  ];

  // returns matching config or undefined
  static getConfig(key: string): OverviewComponentConfig {
    return this.allConfigs.find(
      (config: OverviewComponentConfig): boolean => config.key === key
    );
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<OverviewDisplayComponent>
  ) {
  }
}
